module.exports = __webpack_public_path__ + "img/phil_hero_mobile.bdf08e97.png";